import {makeStyles} from "@material-ui/core/styles";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import {NavigationProps, WizardNavigation, WizardNavigationButton} from "../../../../_shared/wizard/WizardNavigation";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        '& > *': {
            margin: theme.spacing(2),
        },
        '& .MuiTextField-root': {
            width: 300,
        },
    },
}));

interface Props extends NavigationProps {
    onNameChange: (name: string) => void,
}

export const Step1GeneralInfo: React.FC<Props> = ({onNameChange, onChangeTab, ...props}) => {
    const classes = useStyles();
    const [name, setName] = useState<string>('');
    const {t} = useTranslation();

    const handleFormChange = (e: any) => {
        e.preventDefault();
        const value = e.target.value;
        setName(value);
    };

    const onSubmitChange = (changeTab: () => void) => {
        if (!name) return;
        onNameChange(name);
        changeTab();
    }

    const getDisabledButtons = (): Set<WizardNavigationButton> => {
        if (!name)
            return new Set([WizardNavigationButton.Next]);
        return new Set();
    }
    return <Grid container spacing={3}>
        <Grid item xs={12}>
            <Typography variant="body1">{t('ProGuest.Groups.Tabs.General.Description')}</Typography>
            <form className={classes.root} onSubmit={(e) => {
                e.preventDefault();
                onSubmitChange(() => onChangeTab(1))
            }} noValidate
                  autoComplete="off">
                <TextField
                    name='name'
                    value={name}
                    onChange={handleFormChange}
                    label={t('ProGuest.Groups.Name')}
                />
            </form>
            <WizardNavigation {...props} onChangeTab={onChangeTab} onSubmitChange={onSubmitChange}
                              disabledButtons={getDisabledButtons()}/>
        </Grid>
    </Grid>
}
